import React from 'react';

import dashboardWebImg from '../../../../assets/mockups/dashboard-web.png';
import { PillButton } from '../../../../components/PillButton';
import { Reveal } from '../../../../components/Reveal';
import { TiltCard } from '../../../../components/TiltCard';

import {
  Actions,
  Badge,
  BadgeDot,
  Grid,
  Heading,
  Lead,
  MockupCard,
  MockupScreenshot,
  StatCard,
  StatLabel,
  StatsGrid,
  StatValue,
  TrialNote,
  Wrapper,
} from './styles';

const stats = [
  { value: '+170', label: 'exercícios nativos' },
  { value: '2 min', label: 'para prescrever' },
  { value: '15 dias', label: 'grátis, sem cartão' },
];

const Hero: React.FC = () => {
  return (
    <Wrapper>
      <Grid>
        <Reveal direction="left">
          <Badge>
            <BadgeDot />
            Esqueça o papel e as planilhas lentas
          </Badge>

          <Heading>
            Sua academia mais moderna, inteligente e <span>rentável.</span>
          </Heading>

          <Lead>
            Simplifique a gestão do seu negócio e entregue a melhor experiência
            de treino para seus alunos em um único aplicativo.
          </Lead>

          <Actions>
            <PillButton variant="solid" size="lg" href="#cta">
              Começar Teste Grátis
            </PillButton>
            <PillButton variant="ghost" size="lg" href="#recursos">
              Ver funcionalidades
            </PillButton>
          </Actions>

          <TrialNote>
            Zero fidelidade • Cancele quando quiser • Setup em 5 minutos
          </TrialNote>
        </Reveal>

        <Reveal direction="right">
          <MockupCard>
            <TiltCard baseRotateY={-5} baseRotate={-1}>
              <MockupScreenshot>
                <img src={dashboardWebImg} alt="Painel web da TrenzoX" />
              </MockupScreenshot>
            </TiltCard>

            <StatsGrid>
              {stats.map(stat => (
                <StatCard key={stat.label}>
                  <StatValue>{stat.value}</StatValue>
                  <StatLabel>{stat.label}</StatLabel>
                </StatCard>
              ))}
            </StatsGrid>
          </MockupCard>
        </Reveal>
      </Grid>
    </Wrapper>
  );
};

export { Hero };
